import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Icons as I } from './pack-icons';
import '../styles/no-brand-guard.css';

const SURFACES = new Set(['create', 'plan', 'research', 'autopilot']);

export default function NoBrandGuard({ surface, compact = false }) {
  const { t } = useTranslation();
  const safeSurface = SURFACES.has(surface) ? surface : 'create';
  const hintId = `no-brand-guard-hint-${safeSurface}`;

  return (
    <section className={`no-brand-guard${compact ? ' no-brand-guard--compact' : ''}`} aria-labelledby={`no-brand-guard-title-${safeSurface}`}>
      <span className="no-brand-guard__icon" aria-hidden="true"><I.sparkles size={16} /></span>
      <div className="no-brand-guard__copy">
        <h2 id={`no-brand-guard-title-${safeSurface}`}>{t(safeSurface === 'create' ? 'noBrandGuard.createTitle' : 'noBrandGuard.title')}</h2>
        <p id={safeSurface === 'create' ? hintId : undefined}>{t(safeSurface === 'create' ? 'noBrandGuard.createBody' : 'noBrandGuard.body')}</p>
        {safeSurface !== 'create' && <div className="no-brand-guard__preview">
          <span>{t(safeSurface === 'create' ? 'noBrandGuard.optionalLabel' : 'noBrandGuard.previewLabel')}</span>
          {t(`noBrandGuard.${safeSurface}Preview`)}
        </div>}
        {safeSurface !== 'create' && <span id={hintId} className="sr-only">{t('noBrandGuard.disabledHint')}</span>}
      </div>
      <Link className="btn btn-primary no-brand-guard__cta" to="/onboarding">
        {t('noBrandGuard.cta')} <I.arrowRight size={13} />
      </Link>
    </section>
  );
}
